import { Box, Button, Heading, Icon, Modal, Paragraph } from '@zillow/constellation-10';
import { IconInfoOutline } from '@zillow/constellation-icons';
import { ATTACHMENT_UPLOAD_GUIDELINES } from '../../../constants';

type AttachmentGuidelinesProps = {
  onClose(): void;
  shouldShowFileUploadGuidelines?: boolean;
};

export default function AttachmentGuidelines({ onClose, shouldShowFileUploadGuidelines }: AttachmentGuidelinesProps) {
  const heading = shouldShowFileUploadGuidelines ? 'Adding attachments' : 'Attachment guidelines';

  return (
    <Modal
      dividers={false}
      open={true}
      onOpenChange={(isOpen) => !isOpen && onClose()}
      size={{
        base: 'fullScreen',
        md: 'md',
      }}
      header={
        <Heading level={2} textStyle="heading-xs">
          {heading}
        </Heading>
      }
      body={
        <>
          {shouldShowFileUploadGuidelines && (
            <Paragraph textStyle="body-bold" css={{ marginBottom: 'loose' }}>
              {ATTACHMENT_UPLOAD_GUIDELINES}
            </Paragraph>
          )}

          <Box
            css={{
              paddingBlock: 'loose',
              paddingInline: 'default',
              backgroundColor: 'bg.action.neutral.alt.hover',
              border: '1px solid',
              borderColor: 'border.onImpact.feedback.info.strong',
              borderRadius: 'md',
            }}
          >
            <Paragraph textStyle="body-bold">Heads up!</Paragraph>
            <Paragraph>
              For security reasons, we ask that you do not use this chat service to receive personal information,
              including Social Security numbers, credit card numbers, or driver&apos;s license numbers.
            </Paragraph>
          </Box>

          <Box
            css={{
              display: 'flex',
              flexDirection: 'row',
              marginTop: 'loose',
              padding: 'default',
              backgroundColor: 'bg.action.neutral.default',
              border: '1px solid',
              borderColor: 'gray.300',
              borderRadius: 'md',
            }}
          >
            <Box css={{ marginRight: 'tighter' }}>
              <Icon css={{ color: 'gray.500' }} size="md">
                <IconInfoOutline />
              </Icon>
            </Box>
            <Paragraph>Attachments will be deleted 30 days after you send them from the platform.</Paragraph>
          </Box>
        </>
      }
      footer={
        <Button emphasis="filled" onClick={onClose} tone="brand">
          OK
        </Button>
      }
    />
  );
}
